RivalIQ.module('graph', function (graph, App, Backbone, Marionette, $, _, d3) {

    'use strict';

    SparkLine.prototype = new graph.Graph();

    function SparkLine() {
        this.base = graph.Graph;
        this.base();
        this.maxRows = 30;
        this.height = 50;
        this.width = 50;
        this.ticks = 4;
        this.margin.right = 5;
        this.margin.left = 70;
        this.margin.top = 5;
        this.margin.bottom = 25;
        this.zeroThickness = 4;
    }

    graph.SparkLine = SparkLine;

    SparkLine.prototype.render = function () {

        this.clearRendering();
        const width = this.width - this.margin.right - this.margin.left;
        const height = this.height - this.margin.top - this.margin.bottom - this.zeroThickness;

        const yfilt = _.filter(_.map(this.data, 'y'), function (item) {
            return item !== null;
        });
        const xfilt = _.filter(_.map(this.data, 'x'), function (item) {
            return item !== null;
        });

        let ymin = _.min(yfilt);
        let ymax = _.max(yfilt);
        let yRange = ymax - ymin;
        const epsilon = 0.01;

        if (yRange === 0) {
            yRange = ymin;
        }
        ymin = Math.floor(ymin - yRange * 0.4);
        ymin = (ymin < 0) ? 0 : ymin;
        ymax = Math.ceil(ymax + yRange * 0.4);

        if (ymin < epsilon && ymin >= 0) {
            ymin = -0.03;
        }
        if (ymax < epsilon && ymax >= 0) {
            ymax = 0.03;
        }
        const y = d3.scale.linear()
            .domain([ymin, ymax])
            .range([height, 0]);
        const xmin = _.min(xfilt);
        const xmax = _.max(xfilt);
        const x = d3.scale.linear()
            .domain([xmin, xmax])
            .range([0, width]);


        const svg = d3.select(this.target).append('svg')
            .attr('width', width + this.margin.right + this.margin.left)
            .attr('height', height + this.margin.top + this.margin.bottom)
            .append('g')
            .attr('transform', `translate(${this.margin.left},${this.margin.top})`);

        let line = d3.svg.line()
            .x(function (d) {
                return x(d.x);
            })
            .y(function (d) {
                return y(d.y);
            }).defined(function (d) {
                // don't draw null values
                return (d.y !== null);
            });

        svg.append('path')
            .attr('class', 'line')
            .attr('d', line(this.data));

        const yAxis = d3.svg.axis()
            .scale(y)
            .ticks(this.ticks)
            .orient('left');

        const points = _.filter(this.data, function (d) {
            return d.y !== null;
        });
        svg.selectAll('.dot')
            .data(points)
            .enter().append('circle')
            .attr('class', 'dot')
            .attr('cx', line.x())
            .attr('cy', line.y())
            .attr('r', 2.5);

        svg.append('g')
            .attr('class', 'y axis')
            .call(yAxis);

        // BUGBUG these object properties will change when I redo them
        const axisLabels = [
            {
                v: this.dataDateRange.mainPeriodStart.format('ll')
            },
            {
                v: this.dataDateRange.mainPeriodEnd.format('ll')
            }
        ];
        const text = svg.selectAll('text')
            .data(axisLabels, function (d) {
                return d.v;
            })
            .enter().append('g');
        text.append('text')
            .attr('class', function () {
                return 'x-label';
            })
            .attr('x', function (d, i) {
                if (i === 0) {
                    return 0;
                } else {
                    return width;
                }
            })
            .attr('y', function () {
                return height + 10;
            })
            .attr('dx', function (d, i) {
                if (i === 0) {
                    return -5;
                } else {
                    return 5;
                }
            })
            .attr('dy', '1em')
            .attr('text-anchor', function (d, i) {
                if (i === 0) {
                    return 'start';
                } else {
                    return 'end';
                }
            })
            .text(function (d) {
                return d.v;

            });
        line = d3.svg.line()
            .x(function (d) {
                return d.x;
            })
            .y(function (d) {
                return d.y;
            });
        const labelLine1 = [];
        labelLine1.push({
            x: 0,
            y: height + 11
        });
        labelLine1.push({
            x: 0,
            y: height + 5
        });
        svg.append('path')
            .attr('class', 'x-label-line axis')
            .attr('d', line(labelLine1));
        const labelLine2 = [];
        labelLine2.push({
            x: width,
            y: height + 11
        });
        labelLine2.push({
            x: width,
            y: height + 5
        });
        svg.append('path')
            .attr('class', 'x-label-line axis')
            .attr('d', line(labelLine2));
    };

}, window.d3);
